import { Card } from "@/components/ui/card";
import { Network, Users, Clock, Truck } from "lucide-react";

interface Stat {
  label: string;
  value: number;
  icon: React.ComponentType<{ className?: string }>;
}

interface NetworkStatBarProps {
  networks: number;
  brokersConnected: number;
  pendingRequests: number;
  activeLoads: number;
}

/**
 * Horizontal stat bar shown on desktop above the main grid.
 * Mobile falls back to a compact 2x2 grid inside the same card.
 */
export function NetworkStatBar({
  networks,
  brokersConnected,
  pendingRequests,
  activeLoads,
}: NetworkStatBarProps) {
  const stats: Stat[] = [
    { label: "Networks", value: networks, icon: Network },
    { label: "Brokers Connected", value: brokersConnected, icon: Users },
    { label: "Pending Requests", value: pendingRequests, icon: Clock },
    { label: "Active Loads", value: activeLoads, icon: Truck },
  ];

  return (
    <Card className="overflow-hidden">
      <div className="grid grid-cols-2 md:grid-cols-4 divide-y divide-border md:divide-y-0 md:divide-x">
        {stats.map((s) => {
          const Icon = s.icon;
          return (
            <div key={s.label} className="flex items-center gap-3 px-4 py-3 md:px-5 md:py-4">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-teal/10 shrink-0">
                <Icon className="h-4 w-4 text-brand-teal" />
              </div>
              <div className="min-w-0">
                <div className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
                  {s.label}
                </div>
                <div className="text-xl md:text-2xl font-bold text-foreground leading-tight">
                  {s.value.toLocaleString()}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}

export default NetworkStatBar;
